/* eslint-disable sonarjs/no-duplicate-string */
import app from 'Cloud/Application/app';
import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { sendAgreement } from 'reactApp/appHelpers/appHelpers';
import { getQueryParams } from 'reactApp/appHelpers/settingsHelpers';
import { renderLicenseAgreementDialog } from 'reactApp/components/LicenseAgreement/licenseAgreement.toolkit';
import { renderWelcomeAttachesDialogHelper, renderWelcomeDialogHelper } from 'reactApp/components/WelcomeDialog/welcomeDialogToolkit';
import { isDefaultRootContent } from 'reactApp/modules/home/home.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { showUploaderAction } from 'reactApp/modules/upload/upload.module';
import { store as reduxStore } from 'reactApp/store';
import { sendDwh, sendXray } from 'reactApp/utils/ga';
import { noop, noopVoid } from 'reactApp/utils/helpers';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import { EnvironmentSelectors } from '../environment/environment';

export const isWelcomePromo = () =>
    app?.isHome() && app.getState && app.getState().id === '/' && isDefaultRootContent(reduxStore.getState());

const showUploader = () => reduxStore.dispatch(showUploaderAction());

const groupAb = getFeature('ab-trial-popup');

const { utm_source, utm_campaign, utm_term } = getQueryParams();

export const sendAuthDwh = (action: string, source = '') => {
    sendDwh({
        eventCategory: ECategoryGa.onboarding,
        action,
        dwhData: {
            source,
            utm_source,
            utm_campaign,
            utm_term,
        },
    });
};

const sendFirstEnter = () =>
    sendPaymentGa({
        eventCategory: ECategoryGa.onboarding,
        action: 'first-enter',
        label: '',
        group: groupAb || 'None',
    });

let dialog;
export const renderWelcomeHelper = ({
    storage,
    onSuccess = noopVoid,
    publishMode = false,
    onClose = noopVoid,
}: {
    storage: EStorageType;
    onSuccess?();
    onClose?();
    publishMode?: boolean;
}) => {
    const isPhone = EnvironmentSelectors.isPhone();
    const onAccept = () => {
        sendFirstEnter();
        showUploader();
    };

    if (storage === EStorageType.attaches) {
        dialog = renderWelcomeAttachesDialogHelper({
            publishMode,
            onSuccess: () => {
                sendAgreement('mail_', true);
                sendXray('ui_welcome_start-mail');
                if (dialog) {
                    dialog.close();
                    dialog = null;
                }
                onSuccess();
                onAccept();
                sendAuthDwh('license-accept', 'attaches');
            },
            onShow: () => sendAuthDwh('license-open', 'attaches'),
        });

        return;
    }

    if (isPhone) {
        renderLicenseAgreementDialog({
            closable: false,
            onSuccess: () => {
                onAccept();
                sendAuthDwh('license-accept', 'none');
            },
        });

        return;
    }

    renderWelcomeDialogHelper({
        onComplete: showUploader,
        onClose: () => {
            onAccept();
            onClose();
            sendAuthDwh('license-accept', 'none');
        },
        onShow: () => sendAuthDwh('license-open', 'none'),
    });
};

export const isWelcomeDialogShown = (): boolean => !!dialog;
